import React from 'react';
import { GENERATOR_TIPS, EXAM_TYPE_LABELS, cardStyleLabel } from './clinicalOptions.js';

const ClinicalSidebar = ({ settings, creditsDisplay, creditsHint, onOpenSettings }) => (
    <div className="space-y-4">
        <div className="rounded-2xl border border-white/10 bg-slate-900/60 p-4 sm:p-5 text-left">
            <div className="flex items-center gap-2 mb-3">
                <span className="text-lg" aria-hidden>
                    💡
                </span>
                <h4 className="text-sm font-semibold text-white">Pro tips</h4>
            </div>
            <ul className="space-y-2 text-sm text-slate-400 text-left list-none pl-0 m-0">
                {GENERATOR_TIPS.map((tip, i) => (
                    <li
                        key={tip}
                        className={`text-left ${
                            i === 0
                                ? 'rounded-xl border border-teal-500/25 bg-teal-500/10 px-3 py-2.5 text-slate-300'
                                : 'px-1'
                        }`}
                    >
                        {i === 0 && <span className="mr-1 text-teal-300">→</span>}
                        {tip}
                    </li>
                ))}
            </ul>
        </div>

        <div className="rounded-2xl border border-white/10 bg-slate-900/60 p-4 sm:p-5">
            <p className="text-[11px] font-medium uppercase tracking-wider text-slate-500 mb-3">Current settings</p>
            <dl className="space-y-2 text-sm">
                {[
                    ['Prep level', EXAM_TYPE_LABELS[settings.examType] || settings.examType],
                    ['Style', cardStyleLabel(settings.cardStyle, settings.examType)],
                    ['Count', settings.cardCount],
                ].map(([label, value]) => (
                    <div key={label} className="flex items-center justify-between gap-3">
                        <dt className="text-slate-500">{label}</dt>
                        <dd className="text-white font-medium text-right">{value}</dd>
                    </div>
                ))}
            </dl>
            {onOpenSettings && (
                <button
                    type="button"
                    onClick={onOpenSettings}
                    className="mt-4 w-full inline-flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-xs font-medium text-teal-300 bg-teal-500/10 hover:bg-teal-500/15 ring-1 ring-teal-500/20 transition"
                >
                    <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                    Change settings
                </button>
            )}
        </div>

        <div className="rounded-2xl border border-white/10 bg-gradient-to-b from-slate-900/80 to-slate-950/80 p-5 text-center">
            <div className="mx-auto mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-teal-500/15 ring-1 ring-teal-500/30">
                <span className="text-teal-300" aria-hidden>
                    ⚡
                </span>
            </div>
            <p className="text-3xl font-semibold text-white tracking-tight">{creditsDisplay}</p>
            <p className="mt-1 text-sm text-slate-400">Free questions remaining</p>
            {creditsHint && (
                <p className="mt-3 inline-block rounded-full bg-slate-800/80 px-3 py-1 text-[11px] text-slate-400 ring-1 ring-white/10">
                    {creditsHint}
                </p>
            )}
        </div>
    </div>
);

export default ClinicalSidebar;
